import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { po } from "./api";

export function PackagingSettings({ token, center, onClose }) {
  const [m, setM] = useState(null);
  const [def, setDef] = useState(0);
  const [ov, setOv] = useState({});
  const [q, setQ] = useState("");
  useEffect(() => { po("menu", token, { center }).then((r) => { setM(r); setDef(r.settings.packaging_per_item); setOv(r.settings.item_packaging || {}); }).catch((e) => toast.error(e.message)); }, [token, center]);
  const shown = useMemo(() => (m ? m.items.filter((i) => !q || i.name.toLowerCase().includes(q.toLowerCase())).slice(0, 40) : []), [m, q]);
  const save = async () => {
    const clean = Object.fromEntries(Object.entries(ov).filter(([, v]) => v !== "" && v !== null).map(([k, v]) => [k, Number(v)]));
    try { await po("settings/save", token, { center, packaging_per_item: Number(def), item_packaging: clean }); toast.success("Packaging charges saved"); onClose(); }
    catch (e) { toast.error(e.message); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="po-pack-dialog">
        <DialogHeader><DialogTitle>Packaging charges — {center}</DialogTitle></DialogHeader>
        {m && (<div className="space-y-3">
          <div className="space-y-1"><Label className="text-base">Default per item (each quantity)</Label>
            <Input className="h-11 w-40 text-base" type="number" value={def} onChange={(e) => setDef(e.target.value)} data-testid="po-pack-default" /></div>
          <p className="text-sm text-muted-foreground">Set a different charge for specific dishes (leave blank to use the default).</p>
          <Input className="h-11" placeholder="Search dish…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="po-pack-search" />
          {shown.map((i) => (
            <div key={i.key} className="flex items-center justify-between gap-2 border-b py-1">
              <span>{i.name}{i.serves ? ` · ${i.serves}` : ""}</span>
              <Input className="h-9 w-24" type="number" placeholder={String(def)} value={ov[i.key] ?? ""} onChange={(e) => setOv({ ...ov, [i.key]: e.target.value })} data-testid={`po-pack-item-${i.key}`} />
            </div>))}
          <div className="flex justify-end gap-2"><Button variant="outline" onClick={onClose}>Cancel</Button><Button onClick={save} data-testid="po-pack-save">Save</Button></div>
        </div>)}
      </DialogContent>
    </Dialog>
  );
}
